const tokenKey = 'csrf_token'

const userKey = 'login_user'
 
export function getToken() {
  return sessionStorage.getItem(tokenKey)
}
 
export function setToken(token) {
  return sessionStorage.setItem(tokenKey,token)
}
 
export function removeToken() {
  return sessionStorage.removeItem(tokenKey)
}

export function getUser() {
  return JSON.parse(sessionStorage.getItem(userKey))
}
 
export function setUser(userInfo) {
  return sessionStorage.setItem(userKey,JSON.stringify(userInfo))
}
 
export function removeUser() {
  return sessionStorage.removeItem(userKey)
}

export function removeAll() {
  sessionStorage.clear()
}